import { type FC } from 'react';
import { Text } from '@mantine/core';
import { formatOrder, type PayinOrder } from '~/entities/payin';

interface RequisiteProps {
    requisite: PayinOrder['requisite'];
}

export const Requisite: FC<RequisiteProps> = ({ requisite }) => {
    return (
        <>
            {requisite?.card?.number && <Text>{formatOrder.cardNumber(requisite.card.number)}</Text>}

            {requisite?.sbp?.phoneNumber && <Text>{formatOrder.phoneNumber(requisite.sbp.phoneNumber)}</Text>}
        </>
    );
};
